import { render, staticRenderFns } from "./GerenciarDescentralizacoes.vue?vue&type=template&id=26e1c486&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./GerenciarDescentralizacoes.vue?vue&type=style&index=0&id=26e1c486&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e1c486",
  null
  
)

export default component.exports